import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import Icon from '../../Icon';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import Template1Pdf from './Template1Pdf';
import Template2Pdf from './Template2Pdf';
import Template3Pdf from './Template3Pdf';
import Template4Pdf from './Template4Pdf';
import Template5Pdf from './Template5Pdf';
import Template6Pdf from './Template6Pdf';
import Template7Pdf from './Template7Pdf';
import Template8Pdf from './Template8Pdf';
import Template9Pdf from './Template9Pdf';
import Template10Pdf from './Template10Pdf';
import Template11Pdf from './Template11Pdf';
import Template12Pdf from './Template12Pdf';
import Template13Pdf from './Template13Pdf';
import ATSClassicPdf from './ATSClassicPdf';
import ATSModernPdf from './ATSModernPdf';
import ATSCompactPdf from './ATSCompactPdf';


const PDF_TEMPLATES = {
    'ats-classic': ATSClassicPdf, 'ats-modern': ATSModernPdf, 'ats-compact': ATSCompactPdf,
    template1: Template1Pdf, template2: Template2Pdf, template3: Template3Pdf,
    template4: Template4Pdf, template5: Template5Pdf, template6: Template6Pdf,
    template7: Template7Pdf, template8: Template8Pdf, template9: Template9Pdf,
    template10: Template10Pdf, template11: Template11Pdf, template12: Template12Pdf,
    template13: Template13Pdf,
};

function PdfDownloadButton({ state }) {
    const [generating, setGenerating] = useState(false);

    const handleDownload = async () => {
        setGenerating(true);
        try {
            const PdfTemplate = PDF_TEMPLATES[state.template] || Template1Pdf;
            const blob = await pdf(<PdfTemplate {...state} />).toBlob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${state.name || 'resume'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('PDF generation failed:', err);
        } finally {
            setGenerating(false);
        }
    };

    return (
        <button
            type='button'
            className='print-button fs-5 text'
            onClick={handleDownload}
            disabled={generating}
        >
            {' '}
            <Icon icon={faFilePdf} />
            {' '} {generating ? 'Preparing PDF…' : 'Download PDF'}
        </button>
    );
}

export default PdfDownloadButton;